import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropdown"]
  static values = { url: String }

  connect() {
    this.boundSearch = this.search.bind(this)
    this.boundHide = this.hide.bind(this)
    this.inputTarget.addEventListener("input", this.boundSearch)
    document.addEventListener("click", this.boundHide)
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.boundSearch)
    document.removeEventListener("click", this.boundHide)
  }

  search() {
    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      this.dropdownTarget.classList.add("hidden")
      return
    }

    const url = `${this.urlValue}?query=${encodeURIComponent(query)}`
    fetch(url, { headers: { "Accept": "application/json" } })
      .then(response => response.json())
      .then(data => {
        if (data.length === 0) {
          this.dropdownTarget.classList.add("hidden")
          return
        }
        this.dropdownTarget.innerHTML = data.map(item =>
          `<div class="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer truncate"
                data-action="click->autocomplete#select"
                data-value="${this.escapeHtml(item.value || item.label)}">
            ${this.escapeHtml(item.label)}
          </div>`
        ).join("")
        this.dropdownTarget.classList.remove("hidden")
      })
      .catch(() => this.dropdownTarget.classList.add("hidden"))
  }

  select(event) {
    this.inputTarget.value = event.currentTarget.dataset.value
    this.dropdownTarget.classList.add("hidden")
    this.inputTarget.form.requestSubmit()
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add("hidden")
    }
  }

  escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
  }
}
